function insereNotaSemProcessamento(codigoPromocao) {
  $.get(
    '/aliansce/shopping/rest/easypromo/notas/sem/processamento?promocaoId=' + codigoPromocao,
    data => {},
  ).fail((request, status, error) => {
    console.log(error);
  });
}

function getVigencia(idVigencia, sucessFunction, elem) {
  $.get('/aliansce/shopping/rest/easypromo/vigencia/' + idVigencia, data => {
    sucessFunction(JSON.parse(data), elem);
  }).fail((request, status, error) => {
    console.log(error);
  });
}

function getTipoPromo(idVigencia) {
  $.get('/aliansce/shopping/rest/easypromo/vigencia/' + idVigencia, data => {
    const json = JSON.parse(data);
    const response = JSON.parse(json.response);

    tipoPromo = response.tipoTroca;
  }).fail((request, status, error) => {
    console.log(error);
  });
}

function getResumo(codigoPromocao, sigla, sucessFunction) {
  $.ajax({
    url: '/aliansce/shopping/rest/easypromo/notas/resumo/' + codigoPromocao,
    type: 'get',
    dataType: 'json',
    async: true,
    headers: { 'x-promocao': sigla },
    success: sucessFunction,
    error: function (request, status, error) {
      console.log(error);
    },
  });
}

function getCadastro(codigoPromocao, sigla, sucessFunction) {
  $.ajax({
    url: '/aliansce/shopping/rest/easypromo/promocoes/' + codigoPromocao + '/cliente',
    type: 'get',
    dataType: 'json',
    async: true,
    headers: { 'x-promocao': sigla },
    success: sucessFunction,
    error: function (request, status, error) {
      console.log(error);
    },
  });
}

function getVendedores(codigoPromocao, idFilaProcessamento, sucessFunction) {
  $.getJSON(
    '/aliansce/shopping/rest/easypromo/vendedores/' +
      codigoPromocao +
      '/consultar/' +
      idFilaProcessamento,
    { codigoPromocao: codigoPromocao, idFilaProcessamento: idFilaProcessamento },
    data => {
      sucessFunction(data);
    },
  ).fail((request, status, error) => {
    console.log(error);
  });
}

function getEndereco(cep, sucessFunction) {
  $.get('/aliansce/shopping/rest/consultacep/endereco/' + cep, data => {
    sucessFunction(JSON.parse(data));
  }).fail((request, status, error) => {
    console.log(error);
  });
}

function postCadastro(codigoPromocao, sucessFunction, form, sigla) {
  $.ajax({
    url: '/aliansce/shopping/rest/easypromo/promocoes/' + codigoPromocao + '/cliente/cadastro',
    headers: {
      'x-promocao': sigla,
    },
    type: 'post',
    data: JSON.stringify(form),
    success: function (data) {
      sucessFunction(JSON.parse(data));
    },
    error: function (jqXHR, textStatus, errorThrown) {
      dataLayerFormErro(
        jqXHR.status,
        textStatus,
        2,
        'envio-formulario-cadastro-promo',
        'cadastro-promo',
      );
    },
  });
}

///Notas fiscais
function getNotasFiscais(codigoPromocao, sigla) {
  const url = '/aliansce/shopping/rest/easypromo/notas/consultar/' + codigoPromocao;
  let response;
  $.ajax({
    url: url,
    type: 'get',
    async: false,
    headers: { 'x-promocao': sigla },
    success: function (data) {
      response = JSON.parse(data);
    },
    error: function (request, status, error) {
      console.log(error);
    },
  });

  return response;
}

function postNotaFiscalQRCode(codigoPromocao, qrcode, sigla) {
  const url = '/aliansce/shopping/rest/easypromo/notas/cadastrar';

  if (qrcode.indexOf('http') !== -1) {
    qrcode = qrcode.substr(qrcode.indexOf('http'));
  }

  $.ajax({
    url: url,
    type: 'post',
    headers: { 'x-promocao': sigla },
    data: { qrCode: qrcode, codigoPromocao: codigoPromocao },
    success: function (data) {
      data = JSON.parse(data);
      const response = data.response;
      const httpcode = data.httpcode;

      if (httpcode == 202) {
        dataLayerCallbackEnvioNotaPromocao('qr-code');
        idFilaProcessamento = JSON.parse(response).idFilaProcessamento;
        document.getElementById('decodeStatusSucesso').click();
      } else if (httpcode == 422) {
        const msgErro = JSON.parse(response).mensagem.toUpperCase();

        if (
          msgErro.indexOf('CONSULTE A RELAÇÃO DE LOJAS PARTICIPANTES NO REGULAMENTO DA PROMOÇÃO') !=
          -1
        ) {
          $('#msgServico').val(
            'A loja não participa da promoção. Consulte a relação de lojas participantes no regulamento da promoção.',
          );
        } else if (msgErro.indexOf('NOTA FISCAL JÁ CADASTRADA NA PROMOÇÃO') != -1) {
          $('#msgServico').val('Nota já enviada para processamento.');
        } else {
          if (envioFotoHabilitado && envioFotoHabilitado == true)
            $('#msgServico').val(
              'Desculpe, identificamos um problema na leitura. Por favor, tire uma foto da nota.',
            );
          else
            $('#msgServico').val(
              'Desculpe, houve um problema na leitura da nota. Por favor, apresente a nota para verificação na Central de Trocas da Promoção localizada no Shopping.',
            );
        }

        document.getElementById('decodeStatusNegocio').click();
      } else document.getElementById('decodeStatusError').click();
    },
    error: function (request, status, error) {
      console.log(error);
      document.getElementById('decodeStatusError').click();
    },
  });
}

function postNotaFiscalPhotoComVendedor(codigoPromocao, b64, codigoVendedor, sigla) {
  let imagemNota = '';

  if (b64) imagemNota = b64;
  else imagemNota = $('#imagemConvertida').attr('src');

  $.ajax({
    url: '/aliansce/shopping/rest/easypromo/notas/photo',
    type: 'post',
    headers: { 'x-promocao': sigla },
    data: { nota: imagemNota, codigoVendedor: codigoVendedor, codigoPromocao: codigoPromocao },
    success: function (data) {
      const response = JSON.parse(data);

      if (response.httpcode && (response.httpcode == 200 || response.httpcode == 201)) {
        dataLayerCallbackEnvioNotaPromocao('foto-ou-documento');
        document.getElementById('sendPhotoButtonSuccess').click();
      } else {
        document.getElementById('sendPhotoButtonError').click();
      }
    },
    error: function (data) {
      document.getElementById('sendPhotoButtonError').click();
    },
  });
}

function patchVendedorQRCode(codigoPromocao, nomeVendedor, idFilaProcessamento, sigla) {
  const url = '/aliansce/shopping/rest/easypromo/vendedores/atualizar';
  let response;
  $.ajax({
    url: url,
    type: 'Patch',
    headers: { 'x-promocao': sigla },
    data: {
      nomeVendedor: nomeVendedor,
      idFilaProcessamento: idFilaProcessamento,
      codigoPromocao: codigoPromocao,
    },
    success: function (data) {
      response = JSON.parse(data);
      document.getElementById('decodeStatusSucesso').click();
    },
    error: function (request, status, error) {
      console.log(error);
      document.getElementById('skipSellerRecommendation').click();
    },
  });

  return response;
}

//Toggle Tickets info
function toggleTickets() {
  const $item = $('.promo-ticket__item'),
    $itemHeader = $item.find('.promo-ticket__header');

  $itemHeader.each(function () {
    const $this = $(this);
    $this.on('click', () => {
      $itemHeader.not($this).closest($item).removeClass('is--shown');
      $this.closest($item).toggleClass('is--shown');
    });
  });
}

const map = new Map();
let registrationDate = [];
let promoNoteGroups = '';
let newDc;

function getPromoNoteGroups(notes) {
  notes = JSON.parse(notes);

  if (notes.length == 0) return 0;
  else {
    notes.sort(sortNotes);

    notes.forEach((e, i) => {
      const dataCadastro = new Date(e.dataCadastro).toLocaleDateString();

      //date changed
      if (registrationDate.indexOf(dataCadastro) == -1 && i != 0) {
        setRegistrationDate(registrationDate);
        registrationDate = [];
      }

      if (registrationDate.indexOf(dataCadastro) == -1) registrationDate.push(dataCadastro);

      if (!map.get(dataCadastro))
        //is first item to this date
        map.set(dataCadastro, [e]);
      else {
        newDc = [];
        newDc = map.get(dataCadastro);
        newDc.push(e);
        map.set(dataCadastro, newDc);
      }
    });
  }
  setRegistrationDate(registrationDate);

  return promoNoteGroups;
}

function setRegistrationDate(registrationDate) {
  registrationDate.forEach(r_e => {
    const day = map.get(r_e);

    const dayAproved = day.filter(filterByAproved);
    const dayProcessing = day.filter(filterByProcessing);
    const dayRejected = day.filter(filterByRejected);

    dayAproved.sort(sortByNomeLoja);
    dayProcessing.sort(sortByNomeLoja);
    dayRejected.sort(sortByNomeLoja);

    let newNoteGroup = [];
    newNoteGroup.push(
      '<div class="promo-ticket__group">',
      '	<label class="promo-ticket__send-date">Enviado em: <span>' + r_e + '</span></label>',
      '<ul class="promo-ticket__list">',
    );
    newNoteGroup = newNoteGroup.join('');

    promoNoteGroups += newNoteGroup;

    dayAproved.forEach((d_e, i, a) => {
      promoNoteGroups += createNoteItemHTML(d_e);
    });

    dayProcessing.forEach((d_e, i, a) => {
      promoNoteGroups += createNoteItemHTML(d_e);
    });

    dayRejected.forEach((d_e, i, a) => {
      promoNoteGroups += createNoteItemHTML(d_e);
    });

    promoNoteGroups += '</ul></div>';
  });
}

function sortByNomeLoja(a, b) {
  const aNomeLoja = !isNullFromSensidea(a.nomeLoja) ? a.nomeLoja : a.cnpj;
  const bNomeLoja = !isNullFromSensidea(b.nomeLoja) ? b.nomeLoja : b.cnpj;

  if (aNomeLoja < bNomeLoja) return -1;
  if (aNomeLoja > bNomeLoja) return 1;
  return 0;
}

function isNullFromSensidea(e) {
  return e == null || e == 'null';
}

function filterByAproved(el) {
  return el.situacao == APROVADA;
}

function filterByProcessing(el) {
  return el.situacao == EM_PROCESSAMENTO;
}

function filterByRejected(el) {
  return el.situacao == REJEITADA;
}

function createNoteItemHTML(e) {
  let dataEmissao = '--';

  if (!isNullFromSensidea(e.dataEmissao))
    dataEmissao = new Date(e.dataEmissao.replace(/-/g, '/')).toLocaleDateString();

  let nomeLoja = 'NOTA EM ANÁLISE';

  if (!isNullFromSensidea(e.nomeLoja)) nomeLoja = e.nomeLoja;
  else if (!isNullFromSensidea(e.cnpj))
    nomeLoja = e.cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '$1.$2.$3/$4-$5');
  else if (e.situacao && e.situacao == 'REJEITADA') nomeLoja = 'NOTA RECUSADA';

  let numeroNota = '--';

  if (!isNullFromSensidea(e.numero)) numeroNota = e.numero;

  let valor = 'R$ 0,00';
  if (!isNullFromSensidea(e.valor))
    valor = parseFloat(e.valor).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });

  let urlFoto = e.urlFoto;

  if (urlFoto && !isNullFromSensidea(urlFoto) && urlFoto != '')
    urlFoto = '<a href="' + urlFoto + '" class="show-nota">Veja sua nota</a>';
  else urlFoto = '';

  const newNote = [];
  newNote.push(
    '<div class="inner-page__accordion ' +
      getStatusColor(e) +
      '" onclick="$(this).toggleClass(\'visible\')">',
    '<div class="title">',
    '<div class="promo-ticket__store">',
    '<img src="/lumis-theme/br/com/aliansce/shoppings/theme/shoppings-aliansce/assets/images/Nota_analise.svg" alt="" onload="SVGInject(this)" class="img-svg-color" />',
    '<span>' + nomeLoja + '</span>',
    '</div>',
    '<span class="promo-ticket__amount">' + valor + '</span>',
    '<div class="accordion__arrow">',
    '<img src="/lumis-theme/br/com/aliansce/shoppings/theme/shoppings-aliansce/assets/images/open.svg" alt="" onload="SVGInject(this)" class="img-svg-color">',
    '</div>',
    '</div>',
    '<div class="content">',
    '<div class="promo-ticket__wrapper">',
    '<dl class="promo-ticket__info">',
    '<dt class="promo-ticket__label label--number">',
    'Número da nota',
    '</dt>',
    '<dd class="promo-ticket__value value--number">',
    numeroNota,
    '</dd>',
    '<dt class="promo-ticket__label label--data">',
    'Data da compra',
    '</dt>',
    '<dd class="promo-ticket__value value--data">',
    dataEmissao,
    '</dd>',
    '<dt class="promo-ticket__label label--status">',
    '<span>Status</span>',
    '</dt>',
    '<dd class="promo-ticket__value value--status">',
    getStatusMsg(e),
    '</dd>',
    '</dl>',
    urlFoto,
    '</div>',
    '</div>',
    '</div>',
  );

  return newNote.join('');
}

function sortNotes(a, b) {
  if (
    new Date(a.dataCadastro).toLocaleDateString() == new Date(b.dataCadastro).toLocaleDateString()
  )
    return 0;
  if (new Date(a.dataCadastro) < new Date(b.dataCadastro)) return 1;
  if (new Date(a.dataCadastro) > new Date(b.dataCadastro)) return -1;
}

function getStatusClass(responseItem) {
  const situacao = responseItem.situacao;

  switch (situacao) {
    case APROVADA:
      return 'promo-ticket__item--approved';
    case EM_PROCESSAMENTO:
      return 'promo-ticket__item--analyzing';
    case REJEITADA:
      return 'promo-ticket__item--refused';
  }

  return '';
}

function getStatusColor(responseItem) {
  const situacao = responseItem.situacao;

  switch (situacao) {
    case APROVADA:
      return 'promo-ticket__item--approved';
    case EM_PROCESSAMENTO:
      return 'promo-ticket__item--analyzing';
    case REJEITADA:
      return 'promo-ticket__item--refused';
  }

  return '';
}

function getStatusMsg(responseItem) {
  const situacao = responseItem.situacao;

  switch (situacao) {
    case APROVADA:
      return 'Aprovada: A nota foi verificada e está dentro dos requisitos.';
    case EM_PROCESSAMENTO:
      return 'Em processamento: Os dados da nota enviada estão sendo analisados.';
    case REJEITADA:
      if (!isNullFromSensidea(responseItem.motivoRejeicao))
        return 'Recusada: ' + responseItem.motivoRejeicao.replace(';', '');
      else return 'Recusada: A nota enviada não está dentro dos requisitos.';
  }

  return '';
}
